<script lang="ts">
  import type { CtaPanelProps } from '$lib/types/contentTypes';
  import Button from '../../control/Button.svelte';

  export let isNarrow: boolean;
  export let ctaPanel: CtaPanelProps;
</script>

<div class="px-4 lg:px-8 mx-auto {isNarrow ? 'lg:max-w-800' : 'lg:max-w-1280'} ">
  <div
    class="flex flex-col w-full justify-center items-center text-center bg-primary-500 px-6 py-10 sm:p-16 rounded-xxl sm:mx-auto"
  >
    <h2
      class="font-semibold text-display-sm sm:text-display-md pb-4 sm:pb-5 max-w-[28rem] text-white"
    >
      {ctaPanel.heading}
    </h2>
    <p class="font-normal text-lg sm:text-xl max-w-[28rem] text-white pb-8">
      {ctaPanel?.shortDescription}
    </p>
    <div class="flex flex-col sm:flex-row w-full sm:w-auto">
      {#if ctaPanel?.actionCollection?.items?.length}
        {#each ctaPanel?.actionCollection?.items as button}
          <Button
            text={button.text}
            variant={button.variant}
            buttonSize={button.buttonSize}
            url={button.url}
            openInNewTab={button.openInNewTab}
            customClass="!text-primary-500 bg-white border border-white hover:!bg-gray-100 hover:!border-gray-100 hover:!text-primary-500 focus:!shadow-gray-100/95 mr:0 sm:mr-3 mb-3 sm:mb-0 pink_CTA_{button.text
              ?.split(' ')
              .join('_')}"
          />
        {/each}
      {/if}
    </div>
  </div>
</div>
